import { defineStore } from "pinia";
import axios from "axios";
import { getDoc } from "firebase/firestore";
import { useAuthStore } from "./auth";

export const useShopStore = defineStore({
  id: "shop",
  state: () => {
    return {
      storeId: "",
      name: "",
    };
  },
  getters: {
    storeName(state) {
      if (typeof state.name !== "string") {
        return "";
      }

      const normalizedName = state.name.trim();
      return normalizedName || "";
    },
  },
  actions: {
    async getStoreData() {
      try {
        const authStore = useAuthStore();
        const tokenStoreId = authStore?.token?.storeId || "";

        if (!tokenStoreId) {
          return null;
        }

        this.storeId = tokenStoreId;
        const url = `https://99pd3xjl10.execute-api.ap-southeast-1.amazonaws.com/stores/${this.storeId}`;
        const response = await axios.get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.storeId}`,
          },
        });

        const storeData = response?.data || {};

        this.$patch({
          storeId: this.storeId,
          ...storeData,
          name: storeData.name || "",
        });

        return storeData;
      } catch (error) {
        console.log("getStoreData error", error);
        return null;
      }
    },
    async fetchBetaWhiteLists() {
      const authStore = useAuthStore();
      console.log("starting beta...");

      const currentHost = window.location.hostname;

      // check is localhost
      if (currentHost == "localhost") {
        return;
      }

      
      let firestore = useFirestoreXtable();
      let collectionRef = firestore.collectionBetaWhiteList();

      const isBetaSite = currentHost == "order2.xtable.co";

      const docSnap = await getDoc(collectionRef);
      if (docSnap.exists() && !isBetaSite) {
        const data = docSnap.data();

        // if (!data.order) {
        //   return;
        // }    

        const betaData = {
          isBeta: true,       
          storeId: authStore.token.storeId,
          token: authStore.token,
        };

        console.log(JSON.stringify(betaData))

        setCookie("xtable_order", JSON.stringify(betaData), 30, ".xtable.co");

        //window.location.href = `http://localhost:3001/`
        window.location.href = `https://order2.xtable.co`;
        throw new Error("Redirecting to order2");
      }
    },
  },
});
